/**
 * Audit lifecycle status helpers with legacy fallback during rollout.
 */

export function deriveAuditStatusFromData(audit) {
    if (!audit) return null;

    if (audit.completed_at) return 'COMPLETE';

    const explicit = String(audit.status || '').toUpperCase();
    if (explicit === 'COMPLETE') return 'COMPLETE';
    if (audit.form_json != null) return 'DRAFT';
    return 'SCHEDULED';
}

export function resolveAuditStatus(audit) {
    if (!audit) return null;

    if (audit.completed_at) return 'COMPLETE';

    const explicit = String(audit.status || '').toUpperCase();
    if (explicit === 'COMPLETE') return 'COMPLETE';
    if (explicit === 'DRAFT') return 'DRAFT';
    if (audit.form_json != null) return 'DRAFT';
    if (explicit === 'SCHEDULED') return 'SCHEDULED';
    return 'SCHEDULED';
}

export function isAuditComplete(audit) {
    return resolveAuditStatus(audit) === 'COMPLETE';
}

export function isAuditDraft(audit) {
    return resolveAuditStatus(audit) === 'DRAFT';
}

export function isAuditScheduled(audit) {
    return resolveAuditStatus(audit) === 'SCHEDULED';
}
